import {
  httpClient,
  HttpRequestType,
  HttpRequestParamsInterface,
} from '../../../../http-client';
import {ApplicantsApiClientUrlsInterface} from './ApplicantsApiClientUrls.interface';
import {ApplicantsApiClientInterface} from './ApplicantsApiClient.interface';
//import {ApplicantsApiClientInterface} from './ApplicantsApiClient.interface';
import {ApplicantInterface} from '../../..';

export class ApplicantsApiClientModel implements ApplicantsApiClientInterface {
  private readonly urls!: ApplicantsApiClientUrlsInterface;
  private readonly mockDelay: number = 0;
  constructor(options: {
    urls: ApplicantsApiClientUrlsInterface;
    mockDelay?: number;
  }) {
    this.urls = options.urls;
    if (options.mockDelay) {
      this.mockDelay = options.mockDelay;
    }
  }

  fetchApplicants(): Promise<ApplicantInterface[]> {
    const requestParameters: HttpRequestParamsInterface = {
      requestType: HttpRequestType.get,
      url: this.urls.fetchApplicants,
      requiresToken: false,
    };

    //return httpClient.request<ItemInterface[]>(requestParameters)

    // if you want to keep simulating the artificail delay, use this
    if (!this.mockDelay) {
      return httpClient.request<ApplicantInterface[]>(requestParameters);
    } else {
      return new Promise<ApplicantInterface[]>(resolve => {
        httpClient
          .request<ApplicantInterface[]>(requestParameters)
          .then(data => {
            setTimeout(() => {
              resolve(data);
            }, this.mockDelay);
          });
      });
    }
  }

  createApplicant(): Promise<ApplicantInterface[]> {
    const requestParameters: HttpRequestParamsInterface = {
      requestType: HttpRequestType.post,
      url: this.urls.createApplicant,
      requiresToken: false,
    };

    //return httpClient.request<ItemInterface[]>(requestParameters)

    // if you want to keep simulating the artificail delay, use this
    if (!this.mockDelay) {
      return httpClient.request<ApplicantInterface[]>(requestParameters);
    } else {
      return new Promise<ApplicantInterface[]>(resolve => {
        httpClient
          .request<ApplicantInterface[]>(requestParameters)
          .then(data => {
            setTimeout(() => {
              resolve(data);
            }, this.mockDelay);
          });
      });
    }
  }
}
